import { showNotify } from "vendor/application/disptach";

export const validateZendeskEquivalences = (variables, dispatch) => {
    debugger;
    const hasTaggerWithoutEquivalences = variables.some((variable) => {
      const field = variable?.zendesk_ticket_field;
      if (!field) return false;
  
      const isTagger = field.type === "tagger";
      const equivalences = field.equivalences || [];
  
      return isTagger && equivalences.length === 0;
    });
  
    if (hasTaggerWithoutEquivalences) {
      dispatch(
        showNotify({
            message: "extensions_ticket_field_value_is_required",
            severity: "error",
        })
      );
      return true;
    }
  
    return false;
  };
  